export const init = () => {
  const iframe = cube.$id('cp-iframe');

  window.addEventListener('message', messageHandler);
  $(iframe).iFrameResize({checkOrigin:false, resizedCallback});

  const iadvize = cube.$id('iadvize');
  if (iadvize) {
    const observer = new MutationObserver(sendIAdvizeStatus);

    observer.observe(cube.$id('idzfonline'), { attributes: true });
  }
};

const scrollToTop = () => {
  $('html, body').animate({ scrollTop: 0 }, 500);
};

const messageHandler = (event) => {
  const iframe = cube.$id('cp-iframe');
  const customerPortalUrl = iframe.dataset.cpUrl;
  if (event.origin !== customerPortalUrl) {
    return;
  }

  if (typeof event.data === 'object')
    scrollToFormTop(event.data);
  else if (typeof event.data === 'string')
    switch (event.data) {
      case 'ScrollToTop':
        scrollToTop();
        break;

      case 'IAdvize':
        displayChatBox();
        break;

      case 'iframeLoaded':
        iframe.contentWindow.postMessage(localStorage.getItem('dkt_ga_clientId'), customerPortalUrl);
        break;

      default:
        setLocationUrl(event.data);
    }
};

const setLocationUrl = data => {
  if (data.indexOf('[IframeLocation]') !== -1) {
    const array = data.split('|');
    const helpLink = cube.$id('cp-iframe').dataset.helpUrl;
    window.scrollTo(0,0);
    window.history.replaceState({}, null, helpLink + array[1]);
  }
};

const scrollToFormTop = data => {
  const scrollPosition = window.scrollY;
  const formPosition = (scrollPosition - data.formPosition);
  const frameContainer = cube.$id('cp-iframe-container');
  let messageHeight = 0;

  [...frameContainer.children].forEach(child => {
    if (child.tagName === 'IFRAME')
      return true;

    messageHeight += child.offsetHeight;
    return false;
  });

  $('html, body').animate({
    scrollTop: scrollPosition + messageHeight - formPosition
  });
};

const resizedCallback = () => {
  // Remove loading image when iframe resized
  cube.$id('cp-iframe-container').classList.remove('jquery-loading');
};


const sendIAdvizeStatus = event => {
  const iframe = cube.$id('cp-iframe');
  const iadvizeIsOnline = event[0].target.style.display !== 'none';

  iframe.contentWindow.postMessage(
    { iadvizeIsOnline },
    iframe.dataset.cpUrl
  );
};


const displayChatBox = () => {
  const iadvizeButton = cube.$id('iadvize-chat-button');
  iadvizeButton.click();
};



// WEBPACK FOOTER //
// ./src/standalone/sa-helpcenter.js